import React from "react";
import PropTypes from "prop-types";
import { Accordion, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import createMarkup from "helpers/createMarkup";
import styles from "../../landing/landing.module.css";

const FaqAccordionItem = ({ id, title, description, isFirst, isLast }) => {
	return (
		<div className={`${styles.accordionborder} ${styles.accordionStyle} ${isLast ? styles.accordionborderlast : ""}`}>
			<Accordion.Item eventKey={id} className={`border-0 ${styles.accordionborder}`}>
				<div className="p-0" id={`faqAccordionHeading${id}`}>
					<Accordion.Button className={`btn d-block w-100 py-2 px-3 pt-3 border-0 rounded-0 text-start shadow-none ${styles.accordiontitle}`}>
						<div className="d-flex justify-content-between">
							<span className={`font-sans-serif white-force ${styles.accordionStyle}  ${styles.textBold}`}>{title}</span>

							<svg
								width="25px"
								height="25px"
								className={`expanded-icon accordion-icon collapsed-icon me-3 mt-1 ${styles.accordionIcon} ${styles.accordionIcon}`}
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="SVGRepo_bgCarrier" strokeWidth="0" />

								<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

								<g id="SVGRepo_iconCarrier">
									{" "}
									<path
										d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
										fill="#1d8354"
									/>{" "}
								</g>
							</svg>
						</div>
					</Accordion.Button>
				</div>
				<Accordion.Body className="p-0">
					<div className="pt-2">
						<div className={`${styles.paddingem3}  ${styles.accordiontext}`} dangerouslySetInnerHTML={createMarkup(description)} />
					</div>
				</Accordion.Body>
			</Accordion.Item>
		</div>
	);
};

FaqAccordionItem.propTypes = {
	isFirst: PropTypes.bool,
	isLast: PropTypes.bool,
	faq: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
	}),
};

export default FaqAccordionItem;
